import React from "react";
import SignInForm from "./sign-in-form";
import AuthWrapper from "../../shared/auth-layout/auth-wrapper";
import UnderlineShape from "@core/components/shape/underline";

export default function SignIn() {
  return (
    <AuthWrapper
      title={
        <>
          Welcome back! Please{" "}
          <span className="relative inline-block">
            Sign in to
            <UnderlineShape className="absolute -bottom-2 start-0 h-2.5 w-24 text-blue md:w-28 xl:-bottom-1.5 xl:w-36" />
          </span>{" "}
          continue.
        </>
      }
      description="Access your admin dashboard to manage users, review reports, and maintain control of your system."
      // bannerTitle="The simplest way to manage your workspace."
      // bannerDescription="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint velit officia consequat duis."
      isSocialLoginActive={false}
      // pageImage={
      //   <div className="relative mx-auto aspect-[4/3.37] w-[500px] xl:w-[620px] 2xl:w-[820px]">
      //     <img
      //       src="https://isomorphic-furyroad.s3.amazonaws.com/public/auth/sign-up.webp"
      //       alt="Sign Up Thumbnail"
      //       className="object-cover w-full h-full"
      //     />
      //   </div>
      // }
    >
      <SignInForm />
    </AuthWrapper>
  );
}
